module.exports = __webpack_public_path__ + "static/media/vfl-wolfsburg-logo.a4340e09.png";